/* Story LP の動き。
   語彙は PHOTOPRI 会社概要ページ (photopri.com/pages/company) に合わせている
   ── Lenis(lerp 0.08) + GSAP + ScrollTrigger / 行マスクのリベール / js-fade-up /
   画像の内側パララックス / カスタムカーソル。

   🔴 設計の線
   - 初期状態は CSS でなく gsap.set で作る。JS が落ちても本文は見えたままにする。
   - 動きは物語に効く場所だけに置く。いちばん強い pin は「もう一度見る」1箇所に集中させる。
   - prefers-reduced-motion では全部やめる（Lenis も動かさない）。
   - 計測(artstory.js)は scroll イベントに乗っている。Lenis は window を実際にスクロールさせるので
     そのまま動くが、念のため ScrollTrigger.update と併走させる。 */
(function () {
  'use strict';
  var root = document.querySelector('.ast');
  if (!root) return;
  /* テンプレート冒頭の保険が先に .ast-js を外した＝本文はもう静止で見えている（遅い回線） */
  var lateBoot = !document.documentElement.classList.contains('ast-js');

  /* 🔴 WebGL のコンストラクタが定義されていることと、**実際に面が作れること**は別。
     WebGL を無効化した端末（古い Android のブラックリスト等）でも定義は残るので、
     その判定だけ通して model-viewer が内部で落ちる（実測: 'xr' の TypeError が2件）。
     一度だけ本当に context を作って確かめる。 */
  var hasWebGL = (function () {
    try {
      var c = document.createElement('canvas');
      return !!(c.getContext('webgl') || c.getContext('experimental-webgl'));
    } catch (e) { return false; }
  })();

  /* 使えないと分かった時点で初期状態を外す。外し忘れると本文が隠れたままになる。 */
  function bail() { document.documentElement.classList.remove('ast-js'); }

  /* 🔴 2026-10-01 ヒーロー背景の動画は、3D が載ってから読み始める（テンプレートは data-src で渡す）。
     実測（スマホ4G相当）: 動画 1.3MB が 1.1〜3.7秒の回線を占め、その間 model-viewer(254KB) の到着が
     2.4秒まで遅れて、3D の表示が 4.4〜4.6秒になっていた。動画が来るまでは同じ絵の静止画が出ている。
     動きを減らす設定の端末では動画を始めない。 */
  var bgVid = document.querySelector('.ast-hero__bg-vid[data-src]');
  var bgVidOn = false;
  function startVid() {
    if (bgVidOn || !bgVid) return;
    bgVidOn = true;
    bgVid.src = bgVid.dataset.src;   /* autoplay muted playsinline は要素に付いている */
  }
  function startVidAfterLoad() {
    if (document.readyState === 'complete') startVid();
    else window.addEventListener('load', startVid);
  }

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced) { bail(); return; }
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') { bail(); startVidAfterLoad(); return; }

  gsap.registerPlugin(ScrollTrigger);
  document.documentElement.classList.add('ast-motion');

  /* --- 1. 慣性スクロール --- */
  if (typeof Lenis !== 'undefined') {
    var lenis = new Lenis({ lerp: 0.08, smoothWheel: true, orientation: 'vertical' });
    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  var fine = window.matchMedia('(pointer: fine)').matches;

  /* --- 2. カーソル。作品を「見ている」感じを作るためのもので、押せるものは押せるまま --- */
  var cur = document.querySelector('.ast-cursor');
  var fol = document.querySelector('.ast-cursor-follower');
  if (fine && cur && fol) {
    document.documentElement.classList.add('ast-cursor-on');
    var mx = 0, my = 0, fx = 0, fy = 0;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY; gsap.set(cur, { x: mx, y: my });
    });
    gsap.ticker.add(function () {
      fx += (mx - fx) * 0.15; fy += (my - fy) * 0.15;
      gsap.set(fol, { x: fx, y: fy });
    });
    var hot = document.querySelectorAll('a,button,.ast-detail__item img,.ast-resee img,.ast-hero__art img');
    hot.forEach(function (el) {
      el.addEventListener('mouseenter', function () {
        gsap.to(fol, { scale: 2.1, duration: .3, ease: 'power2.out' });
      });
      el.addEventListener('mouseleave', function () {
        gsap.to(fol, { scale: 1, duration: .3, ease: 'power2.out' });
      });
    });
  }

  /* --- 3. 行マスクのリベール（.ast-reveal > .ast-reveal__i） --- */
  function reveal(scope, trigger, opts) {
    var lines = (scope || document).querySelectorAll('.ast-reveal__i');
    if (!lines.length) return null;
  /* 🔴 CSS で初期の transform を与えていると、GSAP は最初にそれを読んで `y` に取り込む。
     そのまま yPercent:0 へ動かしても y に残った 110% 相当の px が効いたままで、行が戻らない
     （実測: 見出しが translate(0,75.4875px) に貼り付いて動かなかった）。
     触るときは必ず y:0 を一緒に指定して、y と yPercent を両方こちらの管理下に置く。 */
    gsap.set(lines, { y: 0, yPercent: 110 });
    return gsap.to(lines, Object.assign({
      y: 0, yPercent: 0, duration: 1.5, stagger: 0.08, ease: 'power4.out',
      scrollTrigger: { trigger: trigger || scope, start: 'top 78%' }
    }, opts || {}));
  }

  /* --- 4. ヒーロー: 絵が現れてから、問いが立ち上がる --- */
  var hero = document.querySelector('.ast-hero');
  if (hero) {
    /* 🔴 2026-09-30 実測: 旧版（blur 付き・計3秒）では、本文が読めるまで PC 3.6秒・スマホ4G 4.4秒かかっていた。
       入りは約1秒に詰め、blur はやめる（大きな画像への filter は低速端末で重い）。
       テンプレート冒頭の保険（2.5秒で .ast-js を外して静止表示）が先に効いた回線では、
       ここで隠し直すと「一度出た見出しが消えて出直す」ので、ヒーローの入りは飛ばす（遅い4Gで11秒目に再生していた）。 */
    if (!lateBoot) {
      var heroLines = hero.querySelectorAll('.ast-reveal__i');
      gsap.set(heroLines, { y: 0, yPercent: 110 });   /* y:0 を必ず添える（上の注記） */
      var tl = gsap.timeline();
      /* 額の静止画は最初から見せたまま（CSS でも隠していない）。入るのは文字だけ */
      tl.fromTo('.ast-hero__id', { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.6, ease: 'power2.out' }, 0)
        .to(heroLines, { y: 0, yPercent: 0, duration: 0.9, stagger: 0.06, ease: 'power4.out' }, 0.05)
        .fromTo('.ast-hero__lede, .ast-hero .ast-cta',
          { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.7, stagger: 0.08, ease: 'power3.out' }, 0.25);
    }

    /* 離れていくときに絵が奥へ引く */
    gsap.to('.ast-hero__art', {
      yPercent: 10, scale: 0.94, opacity: 0.45, ease: 'none',
      scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true }
    });
  }

  /* --- 5. 「もう一度見る」: このページで動きがいちばん効く1箇所。
         絵を画面に留めたまま、少しずつ近づける。 --- */
  var resee = document.querySelector('[data-ast-step="resee"]');
  /* 🔴 拡大する対象は「画像」でなく「印を重ねた箱」。画像だけを scale すると、
     破線と矢印が箱の位置に残り、絵の下端から離れる（実測: SP で 9px ずれた）。 */
  function reseeArt(sec) { return sec.querySelector('.ast-scan__stage') || sec.querySelector('img'); }
  /* 🔴 2026-09-02 Owner 指示。拡大に合わせて論の4歩を出す。
     1 掛ける場所（記録）→ 2 見る位置（推論）→ 3 見上げると地面は入らない（条件）
     → 4 実際この絵に地面が無い（作品で確認）
     🔴 画面に留めるのは**この pin ひとつ**。ここに position:sticky を足すと、
        pin が section に直接 inset/height を書くため sticky の基準が viewport から外れ、
        舞台が 810px ずれた（実測）。留める仕組みを二重に持たせない。
     🔴 歩の数ぶん持ち時間が要るので end を +=90% から伸ばす（5歩で +=330%）。
        90% のままだと1歩あたり 0.18 画面ぶんしかなく、読み終わる前に次が来る。
        歩を足したらここも足すこと。
     🔴 初期状態は JS が作る。CSS で opacity:0 にすると、ここが動かない環境で
        4歩ぶんの本文が丸ごと消える。
     🔴 印（画面外を指す矢印）は最後の歩で出す。拡大が終わってから出るので、
        印だけが本来と違う大きさで見えることはない。 */
  if (resee && !reduced) {
    var img = reseeArt(resee);
    var lead = resee.querySelector('.ast-resee__lead');
    var steps = [].slice.call(resee.querySelectorAll('[data-ast-scan-step]'));
    var marks = [].slice.call(resee.querySelectorAll('.ast-scan__edge, .ast-scan__out'));
    resee.classList.add('is-scan');
    var zFrom = parseFloat(getComputedStyle(resee).getPropertyValue('--zoom-from'));
    if (isNaN(zFrom)) zFrom = 0.62;
    gsap.set(img, { scale: zFrom, transformOrigin: '50% 50%' });
    if (steps.length) {
      /* 🔴 1歩目も 0 から始める（Owner 指摘 2026-09-02）。opacity:1 で置くと、
         節が画面に入りきる前＝pin が始まる前から出たままになる。 */
      gsap.set(steps, { opacity: 0, y: 16 });
      gsap.set(marks, { opacity: 0 });
    }
    /* 🔴 覆い（節をまたぐ面）は **ScrollTrigger の生成時**に渡す。
       あとから .vars へ代入しても登録されない（読むのは生成時の1回だけ）。 */
    var veil = document.querySelector('[data-ast-veil]');
    var detail = document.querySelector('[data-ast-step="detail"]');
    if (veil) gsap.set(veil, { opacity: 0 });
    var rtl = gsap.timeline({
      scrollTrigger: {
        trigger: resee, start: 'top top', end: '+=330%',
        pin: true, scrub: 0.6, anticipatePin: 1
      }
    });
    /* 拡大は最初から最後まで途切れず続ける（歩に合わせて刻むと拡大が止まって見える） */
    var n = steps.length;
    /* 🔴 歩の入れ替えはタイムラインの前 80% で終える。1.0 まで使うと、
       最後の歩が「額が迫る区間」に食われて **4% しか表示されない**（実測でそうなった）。
       残りの 20% は額が画面を埋めるための区間。 */
    var span = 0.80;
    rtl.to(img, { scale: 1, ease: 'none', duration: span + 0.08 }, 0);
    rtl.to(lead, { opacity: 0.35, ease: 'none', duration: 0.18 }, 0);
    if (n) rtl.to(steps[0], { opacity: 1, y: 0, ease: 'none', duration: 0.07 }, 0.02);
    for (var si = 1; si < n; si++) {
      var at = (si / n) * span;
      rtl.to(steps[si - 1], { opacity: 0, y: -12, ease: 'none', duration: 0.05 }, at - 0.04);
      rtl.to(steps[si], { opacity: 1, y: 0, ease: 'none', duration: 0.07 }, at + 0.01);
    }
    /* 🔴 印は「地平線がない…」の歩（＝下から2つ目）に合わせる。最後の歩に置くと、
       額が迫ってくる区間と重なって誰も見ない。 */
    /* 🔴 タイムラインの長さは「いちばん遅く終わるトゥイーン」で決まる。
       ここは 0.94 で終わるので、**progress() は 0〜0.94 を 0〜1 に正規化**してしまい、
       位置指定の数値（0.94 等）と progress の値がずれる。
       実測: progress 0.958 のつもりが実時間 0.90 で、まだ寄りきっていなかった。
       長さ 1.0 の空トゥイーンを置いて、位置＝progress を一致させる。 */
    rtl.to({}, { duration: 0.06 }, 0.94);
    if (n > 1) rtl.to(marks, { opacity: 1, ease: 'none', duration: 0.05 }, ((n - 2) / n) * span + 0.06);

    /* 🔴 次の節へは「下にスクロールして移る」のではなく、**この作品がそのまま
       画面を覆うところまで寄って**切り替わる（Owner 指示 2026-09-02）。
       🔴 覆いきる倍率は画面ごとに違うので定数を置かない。**素の寸法から計算する**
         （offsetWidth/Height は transform の影響を受けないので基準に使える）。
         関数で渡すと ScrollTrigger.refresh のたびに測り直され、画面回転にも追従する。
       🔴 印（画面外を指す矢印）と本文は、覆いにかかる前に引く。一緒に拡大すると
          印だけが巨大になり、本文は絵の下に潜る。 */
    /* 🔴 拡大だけでは覆えない。作品は列の片側に置かれているので、その場で
       大きくしても遠いほうの端に届かない（実測 1440px: 右端 1212 で 228px 足りなかった）。
       中心を画面の中心へ寄せながら拡大する。こうすると必要な倍率も小さくて済み、
       原版の解像度を超えない。 */
    /* 🔴 覆いきるのを 0.94 で終わらせ、残り 0.06 を暗転に使う。
       覆いきりが終端と同じだと、暗転を始める余地がなく「絵が寄っている最中に暗くなる」
       （実測: 幅 831px の時点で既に 22% 暗かった）。先に覆いきってから落とす。 */
    var coverFrom = span + 0.02, coverTo = 0.94;
    var coverBox = function () {
      var w = img.offsetWidth, h = img.offsetHeight;
      var r = img.getBoundingClientRect();
      var sc = (r.width / w) || 1;                     // いま掛かっている倍率
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;
      return { w: w, h: h, cx: cx, cy: cy, sc: sc };
    };
    rtl.to(img, {
      scale: function () {
        var b = coverBox();
        if (!b.w || !b.h) return 2.4;
        return Math.max(window.innerWidth / b.w, window.innerHeight / b.h) * 1.04;
      },
      x: function () { var b = coverBox(); return (window.innerWidth / 2 - b.cx) / b.sc; },
      y: function () { var b = coverBox(); return (window.innerHeight / 2 - b.cy) / b.sc; },
      ease: 'power2.in', duration: coverTo - coverFrom
    }, coverFrom);
    if (n) rtl.to(steps[n - 1], { opacity: 0, ease: 'none', duration: 0.04 }, coverFrom - 0.02);
    rtl.to(lead, { opacity: 0, ease: 'none', duration: 0.04 }, coverFrom - 0.02);
    if (marks.length) rtl.to(marks, { opacity: 0, ease: 'none', duration: 0.04 }, coverFrom - 0.02);

    /* 🔴 覆いきる位置が pin の終端と同じだと、覆われた瞬間に節ごと流れて次へ移れない
       （Owner 指摘 2026-09-02。実測でも覆いは1コマしか保たなかった）。
       覆いきったところで**画面に固定した面**へ渡す。裏でページが次の節まで進み、
       次の節が画面の上端に来たところで面を引く。継ぎ目は見えない。 */
    /* 🔴 面の濃さは **スクロール位置から毎回計算する**。トゥイーンで持たせてはいけない。
       scrub 付きのトゥイーンは「開始前 = 進捗0 = from の値」を保持するので、
       from:1 で作ると **開始位置より手前（ページのほぼ全域）で不透明のまま**になる。
       実際それで「一面に作品が出て戻れなくなった」（Owner 報告 2026-09-02。
       私の往復テストのログにも SP の戻りで 1 のまま残っていたのに、読み違えていた）。
       ここは状態を持たない純関数にして、どこから来ても同じ値に落ち着かせる。
       ①「もう一度見る」の演出が終わりきっていなければ 0（＝作品自身が覆っている区間）
       ② 終わっていれば、次の節の上端が画面の 95% → 20% に来る間で 1 → 0 */
    if (veil && detail) {
      var clamp = function (v) { return v < 0 ? 0 : (v > 1 ? 1 : v); };
      var setVeil = function () {
        /* 🔴 判定は **scrollTrigger.progress（スクロール位置）ではなく
           timeline.progress（実際に描かれている進み）**。scrub は描画が遅れて追いつく
           仕組みなので、スクロールが終端に達した瞬間はまだ寄りきっていない。
           🔴 入りと出を1本の式で持つ。トゥイーンで持たせると、開始位置より手前で
              「進捗0＝from の値」が残り、ページのほぼ全域が塞がる（実測で発生済み）。 */
        var pr = rtl.progress();
        var vh = window.innerHeight || 1;
        var t = detail.getBoundingClientRect().top / vh;
        /* 🔴 しきい値（progress >= 0.999）で場合分けしない。scrub のトゥイーンは
           最後まで詰めきらず 0.998 あたりで落ち着くことがあり、その時に「入りは 0.96、
           出は無効」となって **ページ下部でも面が濃いまま**残った（実測5件）。
           入りと出をどちらも連続量にして、小さいほうを採る。 */
        var opIn = clamp((pr - 0.945) / 0.055);       // 覆いきってから暗転
        var opOut = clamp((t - 0.20) / 0.40);         // 次の節が来たら晴れる
        var op = Math.min(opIn, opOut);
        gsap.set(veil, { opacity: op });
        /* 🔴 暗転しきったら、拡大しきった原画は消す。残すと、晴れる区間で
           次の節の上にもう1枚見える。 */
        gsap.set(img, { opacity: op >= 0.99 ? 0 : 1 });
      };
      /* 🔴 scrub の追いつきはスクロールが止まった後も続くので、
         スクロールイベントだけでは取りこぼす。タイムラインの更新でも呼ぶ。 */
      rtl.eventCallback('onUpdate', setVeil);
      /* 🔴 次の節の切り出しは lazy なので、**覆いの裏で読み込みが始まらない**。
         実測（1.5Mbps 相当）: 覆いが晴れた時点で3枚とも未読込＝空の枠が見えて
         「作品が途切れる」（Owner 実機報告 2026-09-02）。舞台に入った時点で先に取る。 */
      var warmed = false;
      var warm = function () {
        if (warmed) return; warmed = true;
        detail.querySelectorAll('img[loading="lazy"]').forEach(function (im) {
          im.loading = 'eager';
          if (im.decode) im.decode().catch(function () {});
        });
      };
      /* 🔴 濃さの更新は毎フレーム。スクロールイベントだけだと、慣性スクロール中に
         合成側が先に進んで面だけ遅れ、ちらついて見える。 */
      /* 🔴 舞台に入ってからでは間に合わない。**2画面以上手前**で取りに行く
         （実測: pin 開始で切り替えても、晴れる時点でまだ 3枚とも未読込だった）。 */
      if ('IntersectionObserver' in window) {
        var wio2 = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { warm(); wio2.disconnect(); } });
        }, { rootMargin: '250% 0px' });
        wio2.observe(resee);
      } else { warm(); }
      gsap.ticker.add(setVeil);
      window.addEventListener('scroll', setVeil, { passive: true });
      window.addEventListener('resize', setVeil);
      ScrollTrigger.addEventListener('refresh', setVeil);
      setVeil();
    }
  }

  /* 🔴 前の節（絵に近寄る）から、切り出しへ寄りを継ぐ。scale は .js-parallax-img の
     yPercent とは別のトゥイーンだが、GSAP は同じ要素の transform をまとめて持つので競合しない。 */
  document.querySelectorAll('[data-ast-zoom-in]').forEach(function (el) {
    /* 🔴 下限は「覆いの余白 (scale-1)/2 > パララックスの移動量 6%」を満たすこと。
       1.06 だと余白 3% しかなく、スワイプ中に画像の端が枠から外れて途切れた
       （Owner 実機報告 2026-09-02）。1.20 なら余白 10%。 */
    gsap.fromTo(el, { scale: 1.20 }, {
      scale: 1.56, ease: 'none',
      scrollTrigger: { trigger: el.closest('.ast-detail__item') || el,
        start: 'top bottom', end: 'bottom center', scrub: 0.6 }
    });
  });

  /* --- 6. 細部: 切り出しが枠の中でわずかに動く。見に行かせるための動き --- */
  document.querySelectorAll('.js-parallax-img').forEach(function (el) {
    gsap.fromTo(el, { yPercent: -6 }, {
      yPercent: 6, ease: 'none',
      scrollTrigger: { trigger: el.parentElement, start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  /* --- 6b. 読む節の背景に敷いた絵をゆっくり流す。
         後半が文字だけになるとリッチ感が落ちるので、読ませる節にも動く「見るもの」を置く。 --- */
  document.querySelectorAll('.js-backdrop').forEach(function (el) {
    gsap.fromTo(el, { yPercent: -8, scale: 1.08 }, {
      yPercent: 8, scale: 1.14, ease: 'none',
      scrollTrigger: { trigger: el.closest('.ast-backdrop'), start: 'top bottom', end: 'bottom top', scrub: true }
    });
  });

  /* --- 6c. 締めの全図。近づきながら現れる --- */
  var finalArt = document.querySelector('.js-final-art');
  if (finalArt) {
    gsap.fromTo(finalArt, { scale: 0.9, opacity: 0.55 }, {
      scale: 1, opacity: 1, ease: 'none',
      scrollTrigger: { trigger: finalArt, start: 'top bottom', end: 'center center', scrub: 0.5 }
    });
  }

  /* --- 7. 汎用の立ち上がり --- */
  document.querySelectorAll('.js-fade-up').forEach(function (el) {
    gsap.fromTo(el, { y: 36, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1.3, ease: 'power3.out',
      scrollTrigger: { trigger: el, start: 'top 86%' }
    });
  });

  /* 章見出しは行マスクで出す */
  document.querySelectorAll('[data-ast-reveal]').forEach(function (el) { reveal(el, el); });

  /* --- 8. 上から順に。読む順そのものが主張（説 → 確かめられる事 → 正確な言い方） --- */
  document.querySelectorAll('.ast-claims, .ast-moves, .ast-split').forEach(function (box) {
    gsap.fromTo(box.children, { y: 28, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1.1, stagger: 0.14, ease: 'power3.out',
      scrollTrigger: { trigger: box, start: 'top 84%' }
    });
  });

  /* --- 9. 所有への橋。物語の payoff を受けてから開く --- */
  var bridge = document.querySelector('[data-ast-step="bridge"]');
  if (bridge) {
    gsap.fromTo(bridge.querySelector('.ast-cta'),
      { scale: 0.94, opacity: 0 },
      { scale: 1, opacity: 1, duration: 1.1, ease: 'back.out(1.4)',
        scrollTrigger: { trigger: bridge, start: 'top 72%' } });
  }

  /* --- 10. 手紙の一行を、スクロールに連れて1文字ずつ濃くする ---
     jitter.video の scrollAppearText の日本語版。英語は語で割れるが日本語は割れないので、
     文字で割って scrub に載せる。
     🔴 薄さの初期値はここで作る。CSS に書くと JS が落ちた時に読めない文が残る。 */
  var q = document.querySelector('[data-ast-words]');
  if (q && q.textContent.trim()) {
    /* 🔴 1文字ずつ span にすると、どの2文字のあいだでも改行でき「白いア／ーモンド」と
       語の途中で割れる。折ってよい位置は **マークアップ側の .ast-wg** で決めてある。
       🔴 区切りを原稿に「｜」で書かせてはいけない。JS が止まる環境（reduced-motion）で
          その記号が生のまま画面に出る。 */
    var groups = q.querySelectorAll('.ast-wg');
    var chars = [];
    /* 🔴 textContent で入れ直すと、phrase_wbr.py が入れた <wbr>（文節の切れ目）が消え、
          スマホで「湖水でい／っぱい」と割れる（10/25 実測）。文字だけを割り、<wbr> は残す。 */
    function splitInto(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var frag = document.createDocumentFragment();
          c.data.split('').forEach(function (ch) {
            var sp = document.createElement('span');
            sp.className = 'ast-w';
            sp.textContent = ch;
            frag.appendChild(sp);
            chars.push(sp);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.tagName !== 'WBR') {
          splitInto(c);
        }
      });
    }
    if (groups.length) {
      Array.prototype.forEach.call(groups, splitInto);
    } else {
      splitInto(q);
    }
    /* 🔴 舞台（.ast-duo）の中の引用は、**舞台のタイムライン**が動かす。
       ここで薄くしてはいけない。3D が載らない環境ではタイムラインが作られず、
       薄いままの文字が残る（実測: WebGL 無しで 21 文字が 0.16 のまま）。
       薄さを付けるのは、**動かす仕組みが実際に用意できた側**。 */
    if (q.closest('.ast-duo')) {
      window.__astChars = chars;
    } else {
      gsap.set(chars, { opacity: 0.16 });
      gsap.to(chars, {
        opacity: 1, ease: 'none', stagger: 0.7,
        scrollTrigger: { trigger: q, start: 'top 62%', end: 'bottom 52%', scrub: 0.4 }
      });
    }
  }

  /* --- 11. ベントの札は、下からわずかに --- */
  var bento = document.querySelector('.ast-bento');
  if (bento) {
    gsap.fromTo(bento.children, { y: 30, opacity: 0 }, {
      y: 0, opacity: 1, duration: 1.05, stagger: 0.09, ease: 'power3.out',
      scrollTrigger: { trigger: bento, start: 'top 86%' }
    });
  }

  /* --- 12. ヒーローの3D。スクロールに連れてゆっくり回り、寄る。
         🔴 ここは LCP。model-viewer は**後から**足す。最初に見えるのは画像のまま。
         🔴 読み込みに失敗しても何もしない（画像が残る）。3D を前提にした表示を作らない。 --- */
  /* model-viewer の読み込みは1回だけ。ヒーローと、右から左へ通す帯の両方で使う。 */
  var mvJs = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.4.0/model-viewer.min.js';
  var mvQueue = [], mvState = 0;   /* 0=未 1=読込中 2=済 */
  function ensureMV(cb) {
    if (mvState === 2) { cb(); return; }
    mvQueue.push(cb);
    if (mvState === 1) return;
    mvState = 1;
    var sc = document.createElement('script');
    sc.type = 'module'; sc.src = mvJs;
    sc.onload = function () { mvState = 2; mvQueue.splice(0).forEach(function (f) { f(); }); };
    /* 🔴 2026-10-01 手が空くのを待たない。待つと、アプリの読み込みで忙しいスマホでは 0.8秒空いた（実測）。
       「置いてみる」の節が同じ URL を先に読んでいるので、ここで足しても二重には取りに行かない。 */
    document.head.appendChild(sc);
  }

  var art3d = document.querySelector('[data-ast-hero3d]');
  if (!(art3d && art3d.dataset.glb && hasWebGL)) startVidAfterLoad();   /* 3D が無いページ・端末 */
  setTimeout(startVid, 7000);                                           /* 3D が載らなかった時の保険 */
  if (art3d && art3d.dataset.glb && hasWebGL) {
    /* 静止画を 3D の着地に重ねる。数値は実測（ext.js 2026-09-03）: 3D/静止画 = 1.047、
       中心は figure 高さの 6% 下（mv の箱が下へ 12% 伸びているぶんの半分）。
       🔴 ここ（最初の描画前）で当てる。append 時に当てると、その瞬間（約1.2s・フェードイン中）に
          静止画が 18px 動く（実測）。translate/scale は transform と別プロパティなので入場 tween と競合しない。 */
    var heroImg = art3d.querySelector('img');
    var fitImg = function () {
      if (!heroImg) return;
      var H = art3d.getBoundingClientRect().height || 0;
      heroImg.style.translate = '0 ' + (H * 0.06).toFixed(1) + 'px';
      heroImg.style.scale = '1.047';
    };
    fitImg();
    var start = function () {
      var mv = document.createElement('model-viewer');
      mv.setAttribute('src', art3d.dataset.glb);
      /* 🔴 2026-09-03: 初期位置を**着地の向き**にする。下の img が「同じ向きで描き出した透過画像」
         なので、3D は最初からその向きで出て、静止画→3D の入れ替わりが見えなくなる。
         以前は -52deg/150% から 1.5秒かけて寄せていたが、原画の静止画と額付きの 3D が
         別の物として重なって見えていた（Owner 指摘・実測）。入場の動きは捨て、揺れとスクロールだけ残す。 */
      /* 🔴 2026-09-24 縦長の額（正方形・縦長の作品の A2）は、radius 100% の基準（外接球）が
         横長の額と同じなので、同じ距離だと額の高さが画角からはみ出す（実測: 上下が切れる）。
         テンプレートが data-glb-k で距離の倍率を渡す（額装静止画の描き出しの実測比 104/77.2 = 1.347）。
         倍率が無い作品（横長）はこれまでと同じ値になる。 */
      var K = parseFloat(art3d.dataset.glbK) || 1;
      if (K > 1) mv.setAttribute('max-camera-orbit', 'auto auto ' + Math.ceil(150 * K) + '%');
      var pickR0 = function () {
        var b = mv.getBoundingClientRect();
        return ((b.height && b.width / b.height > 1.35) ? 74 : 96) * K;
      };
      /* 🔴 画角は固定しない。固定すると model-viewer の自動フレーミング（radius 100% =
         要素にちょうど収まる距離）が意味を失い、**radius から画面上の大きさを式で出せなくなる**。
         実測: PC で 29990 だった「高さ×radius」が、細い窓では 38478 になり式が外れた。
         画角を戻して 100% を基準に使えば、どの画面の形でも切れないことが保証される。 */
      mv.setAttribute('shadow-intensity', '0.9');
      mv.setAttribute('shadow-softness', '1');
      mv.setAttribute('exposure', '1.05');
      mv.setAttribute('interaction-prompt', 'none');
      mv.setAttribute('disable-zoom', '');
      mv.setAttribute('disable-tap', '');
      mv.setAttribute('loading', 'eager');
      mv.setAttribute('aria-hidden', 'true');   /* 中身は画像の alt で説明済み */
      art3d.appendChild(mv);
      /* 🔴 箱の高さは**載る前から**載った後と同じにする。以前は is-3d が付いた瞬間に
         min-height が効いて figure が伸び、静止画が 42px 上へ跳ねていた（SP 実測: img top 134→92）。
         静止画と 3D が同じ物になった今、この跳ねだけが「入れ替わり」として見える。 */
      var R0 = pickR0();
      mv.setAttribute('camera-orbit', '-17deg 86deg ' + R0 + '%');
      mv.addEventListener('load', function () {
        art3d.classList.add('is-3d');
        startVid();
        /* 🔴 画像を退けるのは CSS でなく JS。ヒーローの入場アニメが img に
           インラインの opacity を残すので、CSS の .is-3d img{opacity:0} は効かない（実測）。 */
        gsap.to(art3d.querySelector('img'), { opacity: 0, duration: 0.6, ease: 'power2.out' });

        /* 🔴 カメラを動かす筋は3本（入場 / 待機の揺れ / スクロール）あるが、
           `camera-orbit` は **1つの属性** なので、別々の tween に書かせると最後に走った
           ものが他を消す。状態だけ別々に持ち、書き込みは ticker の1箇所に集約する。 */
        /* 🔴 radius は「寄り」なので、**箱の形によって安全な値が変わる**。
           68% は PC(1440x506=横長)で測って決めた値で、ブラウザ窓を細くすると
           額の左右が切れた（Owner 指摘・実測で幅が約100px はみ出す）。
           FOV を 20deg に固定してあるので、描画サイズは radius にほぼ反比例する:
             実測 r=68 で 縦441px → k = 441 * 68 ≒ 29990
             見かけの横縦比（額＋余白込み）は実測 589/441 ≒ 1.335
           縦にも横にも収まる最小の radius を毎回この式から出す。 */
        /* 🔴 大きさは自分で計算しない。radius 100% = model-viewer が要素にちょうど収める距離
           なので、そこからの比率だけを決める。画面の形が変わっても切れない。
           自分で式を立てた版は、PC の1点で測った係数が細い窓で外れて額の左右が切れた。 */
        /* 100% を基準に、**箱の形で寄りを2段**に分ける。
           横長の箱（PC・横持ち）は高さで頭打ちになるので寄れる。
           縦長の箱（スマホ縦持ち）は幅で頭打ちになるので寄れない。
           実測(96%時の占有): PC 高さ62% / 縦長の箱 幅86〜99%。 */
        var pickR = pickR0;
        /* 着地の向きから始める（初期 camera-orbit と同じ値。ここがずれると載った瞬間に跳ぶ） */
        var st = { t: -17, p: 86, r: R0 };   /* スクロールが動かす基準 */
        var idle = { t: 0, p: 0 };            /* 待機の揺れ。基準に足すだけ */
        var write = function () {
          mv.setAttribute('camera-orbit',
            (st.t + idle.t).toFixed(2) + 'deg ' + (st.p + idle.p).toFixed(2) + 'deg ' + st.r.toFixed(1) + '%');
        };
        gsap.ticker.add(write);

        /* 3. スクロール: ヒーローを抜けるあいだに、回しながら寄る。
              以前は -24→10deg / 92→78% と振れ幅が小さく「少し動いた」で終わっていた。
           🔴 入場が **終わってから** 作る。scrub の tween は作られた時点の値を始点として
              覚えるので、入場中に作ると進捗0のとき入場前の位置(-52deg/132%)へ引き戻され、
              入場アニメと引っぱり合う。 */
        var scrollTurn = function () {
          gsap.to(st, {
            /* 寄りは 82% まで。100% が「ちょうど収まる」なので、ここを深くすると額の端が切れる */
            t: 24, p: 93, r: R0 * 0.86, ease: 'none',
            scrollTrigger: { trigger: art3d.closest('.ast-hero'), start: 'top top', end: 'bottom top', scrub: 0.6 }
          });
        };

        /* 1. 入場の tween は廃止（上の注記）。着地済みなのでスクロールの筋をすぐ張る。 */
        scrollTurn();

        /* 2. 待機: 止まっていると板に見えるので、常にごく浅く揺らす。
              スクロールしていない間もヒーローが生きている状態にする。 */
        gsap.to(idle, { t: 5.5, duration: 9, ease: 'sine.inOut', yoyo: true, repeat: -1 });
        gsap.to(idle, { p: 2.2, duration: 6.5, ease: 'sine.inOut', yoyo: true, repeat: -1, delay: 1.1 });

        /* 画面を回すと箱の形が変わる。寄りを取り直さないと端が切れる */
        var rt;
        window.addEventListener('resize', function () {
          clearTimeout(rt);
          rt = setTimeout(function () {
            fitImg();
            var nr = pickR();
            if (nr === R0) return;
            R0 = nr;
            gsap.killTweensOf(st);
            gsap.to(st, { r: R0, duration: 0.4, ease: 'power2.out', onComplete: scrollTurn });
          }, 200);
        });


      });
      mv.addEventListener('error', function () { art3d.classList.remove('is-3d'); startVid(); });
    };
    ensureMV(start);
  }

  /* --- 8. 原画の 3D が右から左へ通る帯（引用の節 / アーモンドの節）。
       🔴 見えたときに初めて作る。WebGL の面を3つ常時持たないため。
       🔴 大きさはヒーローと同じ考え方。radius 100% = 要素にちょうど収まる距離なので、
          箱が横長なら寄れる(74%)、縦長なら寄れない(96%)。式は立てない。 --- */
  if (hasWebGL && !reduced) {
    document.querySelectorAll('[data-ast-glide]').forEach(function (el) {
      if (!el.dataset.glb) return;
      var sec = el.closest('section');
      var built = false;
      var build = function () {
        if (built) return; built = true;
        ensureMV(function () {
          var mv = document.createElement('model-viewer');
          mv.setAttribute('src', el.dataset.glb);
          mv.setAttribute('camera-orbit', '-34deg 84deg 110%');
          mv.setAttribute('shadow-intensity', '0.85');
          mv.setAttribute('shadow-softness', '1');
          mv.setAttribute('exposure', '1.05');
          mv.setAttribute('interaction-prompt', 'none');
          mv.setAttribute('disable-zoom', '');
          mv.setAttribute('disable-tap', '');
          mv.setAttribute('camera-controls', 'false');
          /* 🔴 作るかどうかは下の IntersectionObserver（300px 手前）が決めている。
             ここで 'lazy' にすると model-viewer が**自分でもう一段**画面内まで待つので、
             節が画面のすぐ下にあるあいだは載らない（実測 2026-09-03: スクロール 0 のまま
             7秒待っても is-live が付かず、節の高さが 817px のまま。スクロールした
             2.5秒後に 3060px へ跳ねた）。duo をセカンドビューへ上げたので、この跳ねは
             読者の目の前で起きる。作った時点で読み込ませる。 */
          mv.setAttribute('loading', 'eager');
          mv.setAttribute('aria-hidden', 'true');
          el.appendChild(mv);
          mv.addEventListener('load', function () {
            el.classList.add('is-3d');
            var b = el.getBoundingClientRect();
            /* 縦長の額はヒーローと同じ倍率で離す（data-glb-k。無ければ 1 = これまでどおり） */
            var K = parseFloat(el.dataset.glbK) || 1;
            if (K > 1) mv.setAttribute('max-camera-orbit', 'auto auto ' + Math.ceil(150 * K) + '%');
            var st = { t: -34, r: ((b.height && b.width / b.height > 1.35) ? 74 : 96) * K };
            var write = function () {
              mv.setAttribute('camera-orbit', st.t.toFixed(2) + 'deg 86deg ' + st.r.toFixed(1) + '%');
            };
            gsap.ticker.add(write); write();
            /* 🔴 「3D が右→左へ抜け、**空いた側に文字が出る**」の順番は、画面の高さに
               関係なく守られなければならない。ビューポート比で別々の ScrollTrigger を
               張ると、1600px 高の窓で範囲が潰れて文字が最後まで出なかった（実測）。
               **同じタイムラインの位置**で並べれば、どの画面でも必ずこの順になる。 */
            /* 🔴 舞台に切り替えるのは **3D が実際に載ってから**。先に切り替えると、
               model-viewer が落ちた環境で sticky の枡に2つの文章が重なったまま残る。 */
            var duo = sec.classList.contains('ast-duo');
            if (duo) { sec.classList.add('is-live'); ScrollTrigger.refresh(); }

            var tl = gsap.timeline({
              /* 🔴 終点は `bottom top`（節が画面の上へ抜けきる）ではなく
                 `bottom bottom`（節が画面に**収まりきる**）。前者だと、文字が出そろうのは
                 節が画面から出ていく最中で、読む前に消える（実測）。
                 舞台（sticky）は、節の上端が画面上端に来てから下端が画面下端に来るまでが持ち時間。 */
              scrollTrigger: duo
                ? { trigger: sec, start: 'top top', end: 'bottom bottom', scrub: 0.7 }
                : { trigger: sec, start: 'top bottom', end: 'bottom bottom', scrub: 0.7 }
            });
            /* 右から左へ通す。動かすのは箱で、カメラは向きだけ変える */
            /* 🔴 移動範囲は **CSS 変数**から読む。画面幅で安全な量が変わるため
               （実測: 1180px 級だけ絵が文字に 13% 重なった／端まで行くと額が切れた）。
               JS に数字を埋めるとメディアクエリで変えられない。 */
            var cs = getComputedStyle(el);
            var num = function (v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; };
            var gf = num(cs.getPropertyValue('--gf'), 20);
            var gt = num(cs.getPropertyValue('--gt'), -20);
            var gy = num(cs.getPropertyValue('--gy'), 6);
            /* 横だけだと動いて見えにくい。わずかに縦も足して対角に流す */
            tl.fromTo(el, { xPercent: gf, yPercent: -gy, scale: 1 },
              { xPercent: gt, yPercent: gy, ease: 'none', duration: 1 }, 0);
            /* 🔴 大きく出て、渡るあいだに縮み、向こう側でまた大きく戻る（Owner 指示 2026-09-01）。
               縮むのは見た目のためだけでなく、**中央で文字の列に触れないための余白**でもある。
               `translate` は別プロパティなので、GSAP の transform(scale) と競合しない。 */
            var gs = num(cs.getPropertyValue('--gs'), 0.52);
            tl.to(el, { scale: gs, ease: 'sine.inOut', duration: 0.5 }, 0);
            tl.to(el, { scale: 1, ease: 'sine.inOut', duration: 0.5 }, 0.5);
            /* 🔴 渡るあいだに **裏を見せて一周**する（Owner 指示 2026-09-02）。
               CSS の rotateY では model-viewer の canvas が反転するだけで、見えるのは
               前面の鏡像であって額の裏ではない。回すのは**カメラの方位**（-34 → 22 に 360 を足す）。 */
            tl.fromTo(st, { t: -34 }, { t: 382, ease: 'none', duration: 1, onUpdate: write }, 0);
            /* 🔴 額が渡っていくあいだに、文章を入れ替える。
               初期の薄さは **JS が付ける**。CSS で opacity:0 にすると、
               3D が載らない環境で本文が丸ごと消える。 */
            var pa = sec.querySelector('[data-ast-phase="1"]');
            var pb = sec.querySelector('[data-ast-phase="2"]');
            var bg = sec.querySelector('.ast-duo__bg');
            /* 🔴 入れ替えは**画面幅によらず**行う（Owner 指示 2026-09-02）。
               PC は左右ですれ違わせ、スマホは上下に割る。どちらも舞台は固定で、
               「スクロールすると文章が変わる」という見え方は同じ。
               幅で変えてよいのは **寄せ方と額の大きさ**だけ（CSS 側）。 */
            if (duo && pa && pb) {
              gsap.set(pb, { opacity: 0, y: 22 });
              if (bg) gsap.set(bg, { opacity: 0 });
              if (window.__astChars) {
                gsap.set(window.__astChars, { opacity: 0.16 });
                /* 🔴 `stagger.each` は **1文字ごとの間隔**なので、全体の長さが文字数で変わる。
                   21文字 × 0.010 + duration 0.20 = 0.42 まで伸び、**出きる前に消えていた**
                   （Owner 指摘）。`amount` で全体の長さを固定する。 */
                tl.to(window.__astChars, { opacity: 1, ease: 'none',
                  stagger: { amount: 0.16 }, duration: 0.08 }, 0.02);
              }
              /* 🔴 入れ替えの時刻は「額がその文字の列に届く前／離れたあと」で決める。
                 0.40〜0.52 だと、1180px 級で額が第1幕の文字に 5.7%、第2幕に 4.5% 掛かった（実測）。
                 第1幕は額が来る前に引き、第2幕は額が通り過ぎてから出す。
                 あいだの 0.28 ぶんは、額だけが渡っていく間（意図した“間”）。 */
              /* 文字送りが 0.26 で出きる → そこから引く。額は中央で縮んでいるので余白がある。 */
              /* 🔴 時刻は CSS 変数から読む。JS に埋めるとメディアクエリで変えられない
                 （移動量 --gf/--gt と同じ扱い）。 */
              var scs = getComputedStyle(sec);
              var paOut = num(scs.getPropertyValue('--pa-out'), 0.32);
              var bgIn = num(scs.getPropertyValue('--bg-in'), 0.42);
              var pbIn = num(scs.getPropertyValue('--pb-in'), 0.66);
              tl.to(pa, { opacity: 0, y: -18, ease: 'none', duration: 0.10 }, paOut);
              if (bg) tl.to(bg, { opacity: 1, ease: 'none', duration: 0.18 }, bgIn);
              tl.to(pb, { opacity: 1, y: 0, ease: 'none', duration: 0.12 }, pbIn);
            } else {
              var appear = sec.querySelector('[data-ast-appear]');
              if (appear) {
                tl.fromTo(appear, { opacity: 0, x: 26 },
                  { opacity: 1, x: 0, ease: 'none', duration: 0.32 }, 0.68);
              }
            }
          });
          mv.addEventListener('error', function () { el.classList.remove('is-3d'); });
        });
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { build(); io.disconnect(); } });
        }, { rootMargin: '300px 0px' });
        io.observe(sec);
      } else { build(); }
    });
  }

  /* 画像の遅延読み込みで高さが変わるので、揃ったら測り直す */
  window.addEventListener('load', function () { ScrollTrigger.refresh(); });
})();
